/**
 * Validates a URI baseed on the URL constructor
 * @param {*} uri
 * @returns
 */
const validateURI = (uri) => {
  try {
    new URL(uri);
    return true;
  } catch {
    console.debug("Invalid URI: " + uri);
    return false;
  }
};

function isPublic(url) {
  const publicSegments = ["public", "rater", "share"];
  const parsedUrl = new URL(url);
  const pathname = parsedUrl.pathname;
  const pathSegments = pathname.split("/");
  return publicSegments.includes(pathSegments[1]);
}

function isNotPublic(url) {
  return !isPublic(url);
}

function isBetaOrDev(url) {
  const allowedDevTenants = [
    "localhost",
    "test1",
    // "dev1", // to test the prod/invalid case
    "buzz",
    "bob",
    "europa",
    "ganymede",
    "demo",
  ];
  const parsedUrl = new URL(url);
  const hostName = parsedUrl.hostname;
  const parsedHostName = hostName.split(".");
  const parsedTenantName = parsedHostName[0].split("-");
  return (
    parsedTenantName[1] === "beta" ||
    allowedDevTenants.includes(parsedHostName[0])
  );
}

export { isBetaOrDev, isNotPublic, isPublic, validateURI };
